import {
  EuiFlexGroup,
  EuiFlexItem,
  EuiFlyout,
  EuiFlyoutBody,
  EuiFlyoutHeader,
  EuiLink,
  EuiMarkdownFormat,
  EuiPanel,
  EuiText,
  EuiTitle,
} from "@inscopix/ideas-eui";
import moment from "moment";
import { filesize } from "utils/filesize";
import { ContainerDjango } from "./ContainerBrowser.api";
import { Tag } from "./Tag";
import { UserAvatar } from "components/UserAvatar/UserAvatar";
import { useRouteMapContext } from "providers/RouteMapProvider/RouteMapProvider";
import { ContainerUploadingBadge } from "./ContainerCard";
import { ContainerImageStatus } from "types/constants";

interface FlyoutContainerInfoProps extends ContainerDjango {
  onClose: () => void;
}

export const FlyoutContainerInfo = ({
  description,
  date_created,
  date_updated,
  full_name,
  size,
  user,
  tags,
  readme,
  tools,
  tenant,
  status,
  onClose,
}: FlyoutContainerInfoProps) => {
  const toolDynamicPath = useRouteMapContext(
    (s) => s.routeMap["TOOL"].dynamicPath,
  );
  return (
    <EuiFlyout
      type={"push"}
      size="500px"
      onClose={onClose}
      aria-labelledby={"homePagePushedFlyout"}
      pushMinBreakpoint="xxl"
    >
      <EuiFlyoutHeader>
        <EuiFlexGroup direction="row" gutterSize="s" alignItems="center">
          <EuiFlexItem grow={false}>
            <EuiTitle size="m">
              <h2>{full_name}</h2>
            </EuiTitle>
          </EuiFlexItem>
          {status === ContainerImageStatus.UPLOADING && (
            <EuiFlexItem grow={false}>
              <ContainerUploadingBadge />
            </EuiFlexItem>
          )}
        </EuiFlexGroup>
      </EuiFlyoutHeader>

      <EuiFlyoutBody>
        <EuiText size="s">
          <dl>
            <dt>Author:</dt>
            <dd>
              {user !== null ? (
                <UserAvatar userId={user} size="s" displayName />
              ) : (
                "Unknown"
              )}
            </dd>

            <dt>Description:</dt>
            <dd>
              {description === "" || description === null
                ? "None"
                : description}
            </dd>

            <dt>Created:</dt>
            <dd>{moment(date_created).fromNow()}</dd>

            <dt>Updated:</dt>
            <dd>{moment(date_updated).fromNow()}</dd>

            <dt>Storage:</dt>
            <dd>{filesize(size)}</dd>

            <dt>Tags:</dt>
            <dd>
              {tags ? tags.map((tag) => <Tag key={tag} tag={tag} />) : "None"}
            </dd>

            <dt>Overview:</dt>
            <dd>
              {readme !== null && readme !== "" ? (
                <EuiPanel hasBorder>
                  <EuiMarkdownFormat>{readme ?? ""}</EuiMarkdownFormat>
                </EuiPanel>
              ) : (
                "None"
              )}
            </dd>

            <dt>Tools:</dt>
            <dd>
              {tools.length > 0 ? (
                <ul>
                  {tools.map((tool) => (
                    <li key={tool.id}>
                      {tenant == null ? (
                        tool.name
                      ) : (
                        <EuiLink
                          to={
                            toolDynamicPath({
                              tenantKey: tenant.key,
                              toolId: tool.id,
                            }).path
                          }
                        >
                          {tool.name}
                        </EuiLink>
                      )}
                    </li>
                  ))}
                </ul>
              ) : (
                "None"
              )}
            </dd>
          </dl>
        </EuiText>
      </EuiFlyoutBody>
    </EuiFlyout>
  );
};
